import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { SharedDataItemModel } from "../model/shared-data-item.model";
import { SharedDataModel } from "../model/shared-data.model";

@Injectable({
    providedIn: 'root'
})
export class SharedDataService {

    private sharedData: SharedDataModel[] = []
    private updateSubject = new Subject<boolean>();

    constructor() {
    }

    getData(key: string, category?: string): SharedDataItemModel[] {
        let foundData = this.sharedData
            .find(i => i.key == key && i.category == category)

        if(foundData) {
            return foundData.items
        }

        return []
    }

    getNotification(): Observable<boolean> {
        return this.updateSubject.asObservable();
    }

    private notifyUpdated() {
        this.updateSubject.next(true);
    }

    remove(identifier: string) {
        for (const dataKey of this.sharedData) {
            for (let index = 0; index < dataKey.items.length; index++) {
                const item = dataKey.items[index];
                if(item.uid == identifier || item.key == identifier) {
                    dataKey.items.splice(index, 1)
                }
            }
        }
    }

    reset(key: string, category?: string) {
        let foundItemIndex = this.sharedData
            .findIndex(i => i.key == key && (!category || i.category == category))
        
        if(foundItemIndex > -1) {
            this.sharedData.splice(foundItemIndex, 1)
        }
    }

    resetCategory(category: string) {
        for (let index = 0; index < this.sharedData.length; index++) {
            const item = this.sharedData[index];

            if(item.category == category) {
                this.sharedData.splice(index, 1)
            }
        }
    }

    setItem(key: string, item: SharedDataItemModel, category?: string) {
        if(item) {
            let existingDataKey = this.sharedData
                .find(i => i.key == key && 
                           i.category == category)
            
            if(existingDataKey) {
                let existingItem = existingDataKey.items
                    .find(i => (item.uid && i.uid == item.uid) || i.key == item.key)
                
                if(existingItem) {
                    existingItem.key = item.key
                    existingItem.value = item.value
                } else {
                    existingDataKey.items.push({
                        uid: item.uid,
                        key: item.key,
                        value: item.value
                    })
                }
            } else {
                this.sharedData.push({
                    key: key,
                    category: category,
                    items: [{
                        uid: item.uid,
                        key: item.key,
                        value: item.value
                    }]
                })
            }

            this.notifyUpdated()
        }
    }
}